export default function initStickyBlock() {
  const blocks = document.querySelectorAll('.sticky-block');

  blocks.forEach((block) => {
    const isInitialized = block.classList.contains('sticky-block-initialized');
    block.classList.add('sticky-block-initialized');

    const container = block.closest('.sticky-container') as HTMLElement;
    const header = document.querySelector('header')?.children[0] as HTMLElement;
    const breakpointFrom = parseInt((block as HTMLElement).dataset.stickyBreakpointFrom || '0', 10);
    const breakpointTo = parseInt((block as HTMLElement).dataset.stickyBreakpointTo || '0', 10);
    let topOffset = header ? header.offsetHeight : 0;

    function setSticky() {
      const containerRect = container.getBoundingClientRect();
      const blockRect = block.getBoundingClientRect();

      const isStickyEnabled = (!breakpointFrom || window.innerWidth >= breakpointFrom)
        && (!breakpointTo || window.innerWidth < breakpointTo)
        && !(containerRect.top >= topOffset && containerRect.bottom <= window.innerHeight);
      const isStickyTop = block.classList.contains('sticky-top');
      const isStickyBottom = block.classList.contains('sticky-bottom');

      const shouldStickToTop = isStickyEnabled
        && (containerRect.top < topOffset
          || (containerRect.top > window.innerHeight && containerRect.bottom > window.innerHeight));
      const shouldStickToBottom = isStickyEnabled
        && containerRect.bottom < window.innerHeight
        && (blockRect.bottom > containerRect.bottom || isStickyBottom);

      if (shouldStickToBottom) {
        if (!isStickyBottom) {
          block.classList.remove('sticky-top');
          block.classList.add('sticky-bottom');
          block.classList.add('sticky-on');
        }
      } else if (shouldStickToTop) {
        if (!isStickyTop) {
          block.classList.remove('sticky-bottom');
          block.classList.add('sticky-top');
          block.classList.add('sticky-on');
        }
      } else if (isStickyTop || isStickyBottom) {
        block.classList.remove('sticky-top');
        block.classList.remove('sticky-bottom');
        block.classList.remove('sticky-on');
      }
    }

    function handleScroll() {
      setSticky();
    }

    function handleResize() {
      topOffset = header ? header.offsetHeight : 0;
      setSticky();
    }

    if (!isInitialized) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);
    }
    setSticky();
  });
}
